module.exports = __webpack_public_path__ + "img/thumbnail.117e4dc3.png";